export default __webpack_public_path__ + "static/media/gitbook.33722d5d.svg";